







































































import './image-input.css';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ImageInputMixin from './mixin';

@Component({
    name: 'ImageInput',
})
export default class ImageInput extends Mixins(ImageInputMixin) {
    @Prop({ default: false }) readonly!: boolean;

    removeImage() {
        const input = document.getElementById(`image_input_${this.data.key}`) as HTMLInputElement;
        if (input) {
            input.value = '';
        }

        if (this.data.preview) {
            this.$emit('remove-preview');

            return;
        }
    }
}
